import React from "react";
import { graphql } from "gatsby";
import { QuickLinks } from "./QuickLinks";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { getComponentSettings } from "../../../lib/componentSettings";
import {
  KontentComponentSettings,
  KontentComponentLayout,
  KontentLinkedVectorArt,
  KontentLinks,
} from "../../../types";
import { formatVector } from "../../../lib/images";
import { formatLinks } from "../../../lib/links";

interface Props extends KontentComponentSettings, KontentComponentLayout {
  quick_links: {
    value: {
      elements: {
        link_configuration__link: KontentLinks;
        personalization?: {
          value: {
            codename: string;
          }[];
        };
        vector?: KontentLinkedVectorArt;
      };
      system: {
        id: string;
      };
    }[];
  };
  display: {
    value: {
      codename: string;
    };
  };
}

const QuickLinksContainer: React.FC<Props> = ({
  quick_links,
  display,
  ...props
}) => {
  const componentSettings = getComponentSettings({ ...props });
  const quickLinks = quick_links.value.map((quickLink) => {
    const vector = quickLink.elements?.vector?.value[0]
      ? formatVector(quickLink.elements?.vector.value[0].elements)
      : undefined;
    const link =
      quickLink?.elements?.link_configuration__link &&
      formatLinks(
        quickLink.elements?.link_configuration__link?.modular_content
      )[0];

    return {
      vector,
      link,
      personalization: quickLink?.elements?.personalization?.value?.map(
        (value) => value.codename
      ),
      score: 0,
    };
  });

  const displayNumber = display?.value[0]?.codename === "six" ? 6 : 3;

  return (
    <SectionWrapper {...componentSettings}>
      <QuickLinks quicklinks={quickLinks} display={displayNumber}></QuickLinks>
    </SectionWrapper>
  );
};

export default QuickLinksContainer;

export const fragmentQuickLinksContainer = graphql`
  fragment QuickLinks on kontent_item_quick_links {
    system {
      id
      codename
    }
    internal {
      type
      contentDigest
    }
    elements {
      quick_links {
        value {
          ... on kontent_item_quick_link_item {
            system {
              id
            }
            elements {
              link_configuration__link {
                modular_content {
                  ...kontentRichTextLink
                }
              }
              vector {
                value {
                  ...kontentVectorArt
                }
              }
              personalization {
                value {
                  codename
                }
              }
            }
          }
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      display {
        value {
          codename
        }
      }
    }
  }
`;
